import React, { useEffect, useState, useCallback } from "react";
import {
  Card,
  Grid,
  Box,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TablePagination,
  TextField,
} from "@mui/material";
import Indexdasboard from "../../components/dashboard/IndexDashbord";
import { Api_Token } from "../../util/Api";
import { StyledTableCell, StyledTableRow } from "../../assets/style/Table";
import TitreGraphik from "../../components/Typography/TitreGraphik";
import { useNavigate, useParams } from "react-router";
import { CardStatiquepayment } from "../users/DasboardUser";
import { useTranslation } from "react-i18next";
import NumericFormatEnv from "../../components/Numeric/NumericFormatEnv";

export default function PageUserStatistique() {
  return <Indexdasboard Children={<UserStatistique />} />;
}

function UserStatistique() {
  const [statistics, setStatistics] = useState([]);
  const [Paiments, SetPaiments] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const [date, setData] = useState(null);
  const { id } = useParams();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    const filter = date ? `?date=${date}` : "";
    Api_Token.get(`statistique/getStatistiquedUserById/${id}${filter}`)
      .then((response) => {
        setStatistics(response.data);
      })
      .catch((error) => {
        console.error("Error fetching statistics:", error);
      });
  }, [date, id]);

  const fetchChecks = useCallback(
    async (currentPage, rowsPerPage, date) => {
      try {
        const filter = date ? `&date=${date}` : "";
        const response = await Api_Token.get(
          `statistique/getListBookingsByDateUserById/${id}?page=${
            currentPage + 1
          }&perPage=${rowsPerPage}${filter}`
        );
        SetPaiments(response.data.data);
        setTotalCount(response.data.total);
      } catch (error) {
        console.error("Error fetching checks:", error);
      }
    },
    [id]
  );

  useEffect(() => {
    fetchChecks(page, rowsPerPage, date);
  }, [fetchChecks, page, rowsPerPage, date]);

  return (
    <Box>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <TitreGraphik>
            <span onClick={() => navigate(-1)}>⬅</span>
            {t("User Statistique :")} {id}
          </TitreGraphik>
        </Grid>
        <Grid item xs={12}>
          <CardStatiquepayment statistics={statistics} />
        </Grid>
        <Grid item xs={12}>
          <Card sx={{ padding: "2%" }}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <TitreGraphik>{t("List Bookings")}</TitreGraphik>
              <TextField
                type="date"
                value={date}
                onChange={(e) => setData(e.target.value)}
              />
            </Box>
            <TableContainer sx={{ marginTop: "20px" }}>
              <Table sx={{ minWidth: 650 }} aria-label="checks table">
                <TableHead>
                  <StyledTableRow>
                    <StyledTableCell align="center">
                      {t("ID Booking")}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {t("ID Transaction")}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {t("Montant")}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {t("payment method")}
                    </StyledTableCell>
                  </StyledTableRow>
                </TableHead>
                <TableBody>
                  {Paiments?.map((p) => (
                    <StyledTableRow key={p.booking_id}>
                      <StyledTableCell align="center">
                        {p.booking_id}
                      </StyledTableCell>
                      <StyledTableCell align="center">{p.id}</StyledTableCell>
                      <StyledTableCell align="center">
                        <NumericFormatEnv Number={p.montant_paye} />
                      </StyledTableCell>
                      <StyledTableCell align="center">
                        {p.payment_method}
                      </StyledTableCell>
                    </StyledTableRow>
                  ))}
                </TableBody>
              </Table>
              <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                component="div"
                count={totalCount}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </TableContainer>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
}
